var isResettingPrice = false;

window.category =
{
    sortAlias:
    {
        enumNameToAlias:
        {
            "Recommended": "recommended",
            "PriceLowToHigh": "price-asc",
            "PriceHighToLow": "price-desc",
            "NameAscending": "name-asc",
            "NameDescdending": "name-desc",
            "NewestArrival": "newest"
        }
    },

    bindFilterForm: function (form)
    {
        var checkboxes = form.querySelectorAll("input[type=checkbox]");

        checkboxes.forEach(function (checkbox)
        {
            checkbox.addEventListener("change", async function (e)
            {
                await submitAjaxForm(form);

                price.asyncPrice();
            });
        });

        var rangeSliders = form.querySelectorAll("[data-range-slider]");

        for (var rangeSlider of rangeSliders)
        {
            var rangeSliderUi = rangeSlider.querySelector(".range-slider-ui");

            if (rangeSliderUi && !rangeSliderUi.noUiSlider)
                window.cartzilla.createRangeSliderWidget(rangeSlider);
        }

        var priceFilter = form.querySelector("#price-filter");

        if (priceFilter)
            category.bindPriceFilter(priceFilter, form);

        category.bindParameterRangeSliders(form);

        var sortSelect = document.querySelector("select[data-filter-sort]");

        if (sortSelect)
            category.bindSortFilter(sortSelect, form);
    },
    bindPriceFilter: function (priceFilter, form)
    {
        window.category._filterForm = form;

        //var inputMin = priceFilter.querySelector("input[data-range-slider-min]");
        //var inputMax = priceFilter.querySelector("input[data-range-slider-max]");
        var noUiSliderElement = priceFilter.querySelector(".range-slider-ui");

        //inputMin.addEventListener("change", category.priceChanged);
        //inputMax.addEventListener("change", category.priceChanged);

        if (noUiSliderElement && noUiSliderElement.noUiSlider)
        {
            noUiSliderElement.noUiSlider.on("set", (value, handle) =>
            {
                if (isResettingPrice)
                    return;

                category.priceChanged();
            });
        }
    },
    bindParameterRangeSliders: function (form)
    {
        window.category._filterForm = form;

        // Find all parameter range sliders (excluding price filter)
        var parameterRangeSliders = form.querySelectorAll("[data-range-slider]:not(#price-filter)");

        for (let rangeSlider of parameterRangeSliders)
        {
            if (rangeSlider.parentNode.parentNode.id == "price-filter")
                continue;

            //var inputMin = rangeSlider.querySelector("input[data-range-slider-min]");
            //var inputMax = rangeSlider.querySelector("input[data-range-slider-max]");
            var noUiSliderElement = rangeSlider.querySelector(".range-slider-ui");

            //if (inputMin)
            //    inputMin.addEventListener("change", category.parameterRangeChanged);

            //if (inputMax)
            //    inputMax.addEventListener("change", category.parameterRangeChanged);

            if (noUiSliderElement && noUiSliderElement.noUiSlider)
            {
                noUiSliderElement.noUiSlider.on("set", (value, handle) =>
                {
                    if (isResettingPrice) // reuse the same flag for consistency
                        return;

                    category.parameterRangeChanged();
                });
            }
        }
    },
    bindSortFilter: function (select, form)
    {
        select.addEventListener("change", async function (e)
        {
            await category.setSortAsync(select.value, form);
        });
    },
    clearFiltersAsync: async function ()
    {
        var checkBoxes = document.querySelectorAll("[data-product-filter] input[type='checkbox']");

        for (var checkBox of checkBoxes)
            checkBox.checked = false;

        var filterForm = document.querySelector("form[data-product-filter]");

        var priceSlider = document.querySelector("#price-filter .range-slider-ui");

        if (priceSlider)
        {
            isResettingPrice = true;

            priceSlider.noUiSlider.set([priceSlider.noUiSlider.options.range.min, priceSlider.noUiSlider.options.range.max]);

            //category.priceChanged();

            isResettingPrice = false;
        }

        // Reset parameter range sliders
        var parameterRangeSliders = document.querySelectorAll("[data-product-filter] [data-range-slider]:not(#price-filter) .range-slider-ui");

        for (let rangeSlider of parameterRangeSliders)
        {
            if (rangeSlider && rangeSlider.noUiSlider)
            {
                isResettingPrice = true;

                rangeSlider.noUiSlider.set([rangeSlider.noUiSlider.options.range.min, rangeSlider.noUiSlider.options.range.max]);

                isResettingPrice = false;
            }
        }

        await submitAjaxForm(filterForm);

        price.asyncPrice();

        var parameters = new URLSearchParams(window.location.search);
        parameters.delete("params");
        parameters.delete("sf");
        parameters.delete("price");

        window.history.replaceState({}, document.title, window.location.pathname + "?" + parameters.toString());

        category.updateCanonicalUrl();
    },
    getSortAlias: function (value)
    {
        // Supports numeric (string/number) and enum name strings
        if (value === null || value === undefined)
            return null;

        // enum name -> alias
        if (typeof value === "string")
        {
            var trimmed = value.trim();

            // Exact enum name
            if (this.sortAlias.enumNameToAlias[trimmed])
                return this.sortAlias.enumNameToAlias[trimmed];
        }

        return null;
    },
    initFilter: function ()
    {
        var filterForm = document.querySelector("form[data-product-filter]");

        if (filterForm)
            category.bindFilterForm(filterForm);
    },
    parameterRangeChanged: async function (event)
    {
        await submitAjaxForm(window.category._filterForm);

        price.asyncPrice();
    },
    priceChanged: async function (event)
    {
        await submitAjaxForm(window.category._filterForm);

        price.asyncPrice();
    },
    removeFilter: function (property, value)
    {
        var parameters = new URLSearchParams(window.location.search);

        if (property == "sf")
        {
            var checkBox = document.querySelector(`input[name='StaticFilter'][value='${value}']`);

            if (checkBox)
            {
                checkBox.checked = false;

                // trigger change event
                checkBox.dispatchEvent(new Event("change", { bubbles: true }));
            }

            value = value.toLowerCase();

            var staticFilters = (parameters.get("sf") || "").split(',');
            staticFilters = staticFilters.filter(item => item != value);
            staticFilters = staticFilters.join(',');

            parameters.set("sf", staticFilters);
        }
        else if (property == "price")
        {
            var priceSlider = document.querySelector("#price-filter .range-slider-ui");

            isResettingPrice = true;

            priceSlider.noUiSlider.set([priceSlider.noUiSlider.options.range.min, priceSlider.noUiSlider.options.range.max]);

            category.priceChanged();

            isResettingPrice = false;

            parameters.delete("price");
        }
        else
        {
            var escapedProperty = property.replace("~", "\\~"); // escape special characters for query selector e.g. ABRA MS SQL
            var input = document.querySelector(`#filter-${escapedProperty} input[type='hidden'][name$='.Value'][value='${value}']`);
            var parent = null;
            var checkBox = null;

            if (input)
                parent = input.parentNode;

            if (parent)
                checkBox = parent.querySelector("input[type='checkbox']");

            if (checkBox)
            {
                checkBox.checked = false;

                // trigger change event
                checkBox.dispatchEvent(new Event("change", { bubbles: true }));
            }

            var properties = (parameters.get("params") || "").split(';');

            for (var i = 0; i < properties.length; i++)
            {
                var propertyValue = properties[i].split('-');

                if (propertyValue[0] != property)
                    continue;

                var values = propertyValue[1].split(',');

                for (var j = 0; j < values.length; j++)
                {
                    if (values[j] != value)
                        continue;

                    values.splice(j, 1);

                    break;
                }

                if (values.length > 0)
                    properties[i] = property + "-" + values.join(',');
                else
                    properties.splice(i, 1);

                break;
            }

            properties = properties.join(';');

            parameters.set("params", properties);
        }

        window.history.replaceState({}, document.title, window.location.pathname + "?" + parameters.toString());

        category.updateCanonicalUrl();
    },
    removeRangeFilter: function (propertyId)
    {
        // Reset the range slider to its full range
        var escapedProperty = propertyId.replace("~", "\\~"); // escape special characters for query selector e.g. ABRA MS SQL
        var rangeSlider = document.querySelector(`#filter-${escapedProperty} .range-slider-ui`);

        if (rangeSlider && rangeSlider.noUiSlider)
        {
            isResettingPrice = true;

            rangeSlider.noUiSlider.set([rangeSlider.noUiSlider.options.range.min, rangeSlider.noUiSlider.options.range.max]);

            category.parameterRangeChanged();

            isResettingPrice = false;
        }

        // Update URL parameters - remove the entire property from params
        var parameters = new URLSearchParams(window.location.search);
        var properties = (parameters.get("params") || "").split(';');

        // Remove the property from params
        properties = properties.filter(prop => !prop.startsWith(`${propertyId}-`));

        var joinedProperties = properties.join(';');

        if (joinedProperties)
            parameters.set("params", joinedProperties);
        else
            parameters.delete("params");

        window.history.replaceState({}, document.title, window.location.pathname + "?" + parameters.toString());

        category.updateCanonicalUrl();
    },
    setSortAsync: async function (value, form)
    {
        var targetForm = form || document.querySelector("form[data-product-filter]");

        var input = targetForm.querySelector("input[name='SortFilter']");

        if (!input)
            return;

        input.value = value;

        await submitAjaxForm(targetForm);

        price.asyncPrice();

        // Keep selected sort in the URL so it can be shared
        var alias = category.getSortAlias(value);

        var parameters = new URLSearchParams(window.location.search);

        if (alias)
            parameters.set("sort", alias);
        else if (value !== undefined && value !== null && value !== "")
            parameters.set("sort", String(value)); // fallback
        else
            parameters.delete("sort");

        window.history.replaceState({}, document.title, window.location.pathname + "?" + parameters.toString())

        category.updateCanonicalUrl();
    },
    updateCanonicalUrl: function ()
    {
        // Synchronize canonical URL with current filter state (params, sf, price, sort),
        // preserve any other existing canonical query strings,
        // force page=1 if page exists.

        var canonicalLink = document.querySelector("link[rel='canonical']");

        if (!canonicalLink)
            return;

        // Use absolute URL resolution
        var canonicalUrl = new URL(canonicalLink.getAttribute("href"), window.location.origin);
        var canonicalParams = canonicalUrl.searchParams;
        var currentParams = new URLSearchParams(window.location.search);

        var keysToSync = ["params", "sf", "price", "sort"];

        for (var i = 0; i < keysToSync.length; i++)
        {
            var key = keysToSync[i];

            if (currentParams.has(key))
                canonicalParams.set(key, currentParams.get(key));
            else
                canonicalParams.delete(key);
        }

        if (canonicalParams.has("page"))
            canonicalParams.set("page", "1");

        canonicalUrl.search = canonicalParams.toString();

        canonicalLink.setAttribute("href", canonicalUrl.toString());
    },
    updateParamUrl: function ()
    {
        var filterForm = document.querySelector("form[data-product-filter]");

        if (!filterForm)
            return;

        var properties = [];
        var staticFilters = [];
        var priceFilter = null;

        var checkBoxes = filterForm.querySelectorAll(".form-check, div[data-checkbox]");

        checkBoxes.forEach(checkBox =>
        {
            var input = checkBox.querySelector("input[type=checkbox]");

            if (!input.checked)
                return;

            if (input.dataset.static == "true")
            {
                staticFilters.push(input.value.toLowerCase());

                return;
            }

            var propertyId = checkBox.querySelector("input[name$=PropertyId]").value;
            var valueId = checkBox.querySelector("input[name$=Value]").value;

            if (!properties[propertyId])
                properties[propertyId] = [];

            properties[propertyId].push(valueId);
        });

        // Handle range sliders (both price and parameter ranges)
        var rangeSliders = filterForm.querySelectorAll("[data-range-slider]");

        for(let rangeSlider of rangeSliders)
        {
            var noUiSliderElement = rangeSlider.querySelector(".range-slider-ui");

            if (!noUiSliderElement || !noUiSliderElement.noUiSlider)
                continue;

            var values = noUiSliderElement.noUiSlider.get(true);
            var range = noUiSliderElement.noUiSlider.options.range;

            // Check if the slider is at its default position (inactive)
            var isInactive = Math.floor(range.min) == Math.floor(values[0]) && Math.floor(range.max) == Math.floor(values[1]);

            if (isInactive)
                continue;

            var parentId = rangeSlider.parentNode.parentNode.id;

            // Handle price filter
            if (parentId === "price-filter")
            {
                priceFilter = `${values[0]},${values[1]}`;
            }
            else
            {
                // Handle parameter range filters
                // Extract property ID from the slider's ID (e.g., "filter-PropertyId" -> "PropertyId")
                var propertyId = parentId.replace("filter-", "");

                if (propertyId)
                {
                    if (!properties[propertyId])
                        properties[propertyId] = [];

                    // Add min and max values with suffixes to distinguish them
                    properties[propertyId].push(`${values[0]}`);
                    properties[propertyId].push(`${values[1]}`);
                }
            }
        }

        var params = [];

        for (var propertyId in properties)
        {
            var values = properties[propertyId];
            var joinedValues = values.join(",");

            params.push(propertyId + "-" + joinedValues);
        }

        params = params.join(";");

        var staticFiltersString = staticFilters.join(",");

        //var priceFilterMin = filterForm.querySelector("input[name='PriceFilter[0]'");
        //var priceFilterMax = filterForm.querySelector("input[name='PriceFilter[1]'");

        //if (priceFilterMin && priceFilterMax)
        //{
        //    var noUiSliderElement = filterForm.querySelector("#price-filter .range-slider-ui");

        //    if (noUiSliderElement && noUiSliderElement.noUiSlider)
        //    {
        //        var values = noUiSliderElement.noUiSlider.get(true);

        //        var range = noUiSliderElement.noUiSlider.options.range;

        //        var isInactive = range.min == values[0] && range.max == values[1];

        //        priceFilter = isInactive
        //            ? null
        //            : `${values[0]},${values[1]}`;
        //    }
        //}

        var parameters = new URLSearchParams(window.location.search);

        if (params)
            parameters.set("params", params);
        else
            parameters.delete("params");

        if (staticFiltersString)
            parameters.set("sf", staticFiltersString);
        else
            parameters.delete("sf");

        if (priceFilter)
            parameters.set("price", priceFilter);
        else
            parameters.delete("price");

        window.history.replaceState({}, document.title, window.location.pathname + "?" + parameters.toString());

        category.updateCanonicalUrl();
    }
};

document.addEventListener("DOMContentLoaded", function (e)
{
    category.initFilter();
});

//export default productFilter;